/**
 * Shared Google Maps configuration.
 *
 * ALL components that load Google Maps MUST use this config to prevent
 * "Loader must not be called again with different options" errors.
 * The Google Maps JS API loader is a singleton — if two components
 * request different library sets, the second load throws.
 */

/** Libraries required across all map features in the app */
export const GOOGLE_MAPS_LIBRARIES: ('places' | 'geometry')[] = ['places', 'geometry'];

/** Shared loader options for useJsApiLoader */
export const GOOGLE_MAPS_LOADER_OPTIONS = {
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  libraries: GOOGLE_MAPS_LIBRARIES,
} as const;
